import React from 'react'
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'

export type ConsultationsIconProps = SvgIconProps

export function ConsultationsIcon(props: ConsultationsIconProps) {
  const { htmlColor } = props
  return (
    <SvgIcon width="200" height="200" viewBox="0 0 200 200" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="My_teleconsultations">
        <g>
          <g id="XMLID_00000047741926242438198540000004000257676241045652_">
            <g>
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M184.86,19.461v120.97c0,1.1-0.9,2-2,2h-11.95h-49.68h-15.27H93.83H78.56H18.17
					c-1.67,0-3.03-1.36-3.03-3.03V19.461c0-1.68,1.36-3.03,3.03-3.03h163.66C183.5,16.431,184.86,17.781,184.86,19.461z
					 M174.57,132.141V26.851H25.43v105.29H160.1H174.57z"
              />
              <polygon
                style={{ fill: htmlColor || '#A7A9AC' }}
                points="141.14,173.281 141.14,183.571 58.86,183.571 58.86,173.281 74.29,173.281 
					125.5,173.281 				"
              />
              <path
                style={{ fill: htmlColor || '#A7A9AC' }}
                d="M70.44,72.181l-0.14-0.04v-5.77l-0.19-0.3l0.76-0.48c1.12-0.59,1.86-1.71,1.95-2.97l0.75-9.33
					c0-4.29-3.48-7.77-7.78-7.77c-4.29,0-7.77,3.48-7.77,7.77l0.75,9.33c0.09,1.26,0.83,2.38,1.95,2.97l0.71,0.46l-0.21,0.32v5.77
					h-0.01l-10.26,3.49c-0.76,0.26-1.27,0.96-1.27,1.76v5.12c-5.66-4.69-9.26-11.78-9.26-19.71c0-14.12,11.45-25.57,25.58-25.57
					c14.12,0,25.58,11.45,25.58,25.57c0,8.15-3.81,15.41-9.75,20.1v-5.51c0-0.8-0.5-1.5-1.25-1.76L70.44,72.181z"
              />
            </g>
            <g>
              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="125.5,173.281 
					141.14,173.281 141.14,183.571 58.86,183.571 58.86,173.281 74.29,173.281 				"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M105.96,143.251v12.13
					c0,3.33-2.73,6.06-6.07,6.06c-3.33,0-6.06-2.73-6.06-6.06v-12.13"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M78.56,143.251v15.61
					c0,5.2-1.58,10.08-4.27,14.12"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M121.23,143.251v15.61
					c0,5.2,1.58,10.08,4.27,14.12"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M78.56,142.431H18.17
					c-1.67,0-3.03-1.36-3.03-3.03V19.461c0-1.68,1.36-3.03,3.03-3.03h163.66c1.67,0,3.03,1.35,3.03,3.03v120.97c0,1.1-0.9,2-2,2
					h-11.95h-49.68h-15.27H93.83H78.56z"
              />
              <polygon
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="160.1,132.141 
					25.43,132.141 25.43,26.851 174.57,26.851 174.57,132.141 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="44.86"
                y1="106.431"
                x2="70.57"
                y2="106.431"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="44.86"
                y1="116.711"
                x2="60.29"
                y2="116.711"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="68"
                y1="116.711"
                x2="88.57"
                y2="116.711"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M49.68,82.511
					c-5.66-4.69-9.26-11.78-9.26-19.71c0-14.12,11.45-25.57,25.58-25.57c14.12,0,25.58,11.45,25.58,25.57
					c0,8.15-3.81,15.41-9.75,20.1c-1.42,1.11-2.95,2.08-4.59,2.87c-3.39,1.68-7.2,2.61-11.24,2.61c-4.03,0-7.86-0.93-11.25-2.61
					C52.92,84.891,51.23,83.791,49.68,82.511z"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M81.83,82.901v-5.51
					c0-0.8-0.5-1.5-1.25-1.76l-10.14-3.45l-0.14-0.04v-5.77"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M61.22,66.371v5.77h-0.01
					l-10.26,3.49c-0.76,0.26-1.27,0.96-1.27,1.76v5.12"
              />
              <path
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                d="M70.11,66.071l0.76-0.48
					c1.12-0.59,1.86-1.71,1.95-2.97l0.75-9.33c0-4.29-3.48-7.77-7.78-7.77c-4.29,0-7.77,3.48-7.77,7.77l0.75,9.33
					c0.09,1.26,0.83,2.38,1.95,2.97l0.71,0.46l3.05,2.01h2.49L70.11,66.071z"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="61.21,72.141 
					64.13,75.441 67.56,75.441 70.44,72.181 70.48,72.141 				"
              />
              <polyline
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                points="101.51,58.381 
					113.62,58.381 121.08,72.031 127.44,46.061 133.58,73.301 139.49,48.251 144.22,69.571 149.5,59.681 161.3,59.681 				"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="128.86"
                y1="94.601"
                x2="161.3"
                y2="94.601"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="128.86"
                y1="106.431"
                x2="161.3"
                y2="106.431"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="128.86"
                y1="118.261"
                x2="161.3"
                y2="118.261"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="121.11"
                y1="94.601"
                x2="117.13"
                y2="94.601"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="121.11"
                y1="106.431"
                x2="117.13"
                y2="106.431"
              />

              <line
                style={{
                  fill: 'none',
                  stroke: htmlColor || '#000000',
                  strokeWidth: 4,
                  strokeLinecap: 'round',
                  strokeMiterlimit: 10,
                }}
                x1="121.11"
                y1="118.261"
                x2="117.13"
                y2="118.261"
              />
            </g>
          </g>
        </g>
      </g>
      <g id="Layer_1"></g>
    </SvgIcon>
  )
}

export default ConsultationsIcon
